import React, { FC } from 'react';

type Props = {
  classCss?: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconPorcentaje: FC<Props> = ({ classCss, props }) => {
  return (
    <svg
      className={classCss}
      {...props}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="Symbols" stroke="none" fill="none">
        <g id="Icon-/-porcentaje" fill="#393D49">
          <path
            d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M17,5.58578644 L5.58578644,17 L7,18.4142136 L18.4142136,7 L17,5.58578644 Z M16.0014804,14 C14.8971135,13.9992604 14.0007407,14.8954674 14,15.9981499 C13.9992603,17.1015724 14.8941527,17.9992595 15.9985196,18 C17.1028865,18.0007396 17.9992593,17.1045326 18,16.0011101 C18.0007397,14.8984276 17.1058473,14.0007405 16.0014804,14 Z M8.00148038,6 C6.8971135,5.9992604 6.00074065,6.89546741 6,7.99814986 C5.99926027,9.10157237 6.89415273,9.99925949 7.99851962,10 C9.1028865,10.0007396 9.99925935,9.10453259 10,8.00111008 C10.0007397,6.89842763 9.10584727,6.00074051 8.00148038,6 Z"
            id="Combined-Shape"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconPorcentaje;
